import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import cellWithEditing from './CellWithEditing';
import GroupForm from './GroupForm';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import '../ManageUsers/ManageUser.scss';
import axios from 'axios';
import { Alert } from 'reactstrap';
import { PositionGroupsLoader } from './PositionGroupsLoader';
import { ROOT_API_URL } from '../../../../../api-config';
import { getGroupTypes, addPositionGroup, updatePositionGroup } from '../../../../../Redux/Actions/Admin/ManagePositionGroupAction';
import { connect } from 'react-redux';
import { auth } from '../../../../../services/auth.service';

const FileDownload = require('js-file-download');

class ManagePositionGroups extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isSubmitted: false,
            groupInEdit: {},
            isPopupVisible: false,
            groups: { data: [], total: 0 },
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Description", dir: "asc" }]
            },
            alertVisible: false,
            alertColor: "danger",
            alertMessage: ""
        };
    }

    componentDidMount() {
        this.props.getGroupTypes();
    }

    dataStateChange = (e) => {
        if (e.data && e.data.filter && e.data.filter.filters) {
            var filters = e.data.filter.filters;

            for (var i = 0; i < filters.length; i++) {
                if (filters[i].value == null) {
                    filters[i].value = "";
                }
            }
        }

        this.setState({
            ...this.state,
            dataState: e.data
        });
    }

    dataRecieved = (groupsFetched) => {
        this.setState({
            ...this.state,
            groups: groupsFetched,
            isLoading: false
        });
        console.log('groups Fetched', groupsFetched);

        if (groupsFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
            let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
        }
        else if (groupsFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
            document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
        }
    }

    edit = (dataItem) => {
        this.setState({
            groupInEdit: Object.assign({}, dataItem),
            isPopupVisible: true
        });
    };

    cancel = () => {
        this.setState({ isPopupVisible: false })
    };

    stringifyObj = (arr) => {
        let t = [...arr];
        if (!t) {
            return null;
        }
        else {
            for (var i = 0; i < t.length; i++) {
                var element = { ...t[i] };
                for (var key in t[i]) {
                    element[key] = element[key] + '';
                }
                t[i] = element;
            }
            return t;
        }
    }

    exportToExcel = () => {
        var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
        var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
        var KendoGridQuery = {
            Filters: Filters ? Filters.slice() : [],
            Sorts: Sorts ? Sorts.slice() : []
        }

        axios.get(ROOT_API_URL + "/ManagePositionGroup/ExportToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
            .then((response) => {
                FileDownload(response.data, 'Groups.csv');
            }).catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to export to excel';

                this.setState({
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    }

    toggleActive = (dataItem) => {
        dataItem.IsActive = !dataItem.IsActive;
        dataItem.PositionGroupType = Number(dataItem.PositionGroupType);
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Description", dir: "asc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManagePositionGroup/TogglePositionGroupActivity`, dataItem, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to delete the position group.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    };

    addNew = () => {
        this.setState({
            isPopupVisible: true,
            groupInEdit: {}
        });
    }

    save = (model) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Description", dir: "asc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManagePositionGroup/SavePositionGroup`, model, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to save the position group.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    }

    render() {
        return (
            <div id={"positionGroups-grid"}>
                <AdminHeader />
                {this.state.isLoading ?
                    (<div>
                        <IsLoading message="Loading position groups" />
                    </div>

                    ) :
                    (
                        <div>
                            <Alert
                                color={this.state.alertColor}
                                isOpen={this.state.alertVisible}
                                toggle={() => {
                                    this.setState({ alertVisible: false, alertMessage: "" })
                                }}
                            >
                                {this.state.alertMessage}
                            </Alert>
                            <Grid
                                style={{ width: '80vw', height: '80vh' }}
                                filterable={true}
                                sortable={true}
                                pageable={true}
                                total={this.state.groups.total}
                                {...this.state.dataState}
                                {...this.state.groups}
                                onDataStateChange={this.dataStateChange}
                                resizable
                                reorderable={true}
                            >
                                <GridToolbar>
                                    <div className="admin-grid-toolbar-box2">
                                        <button onClick={this.addNew} className="admin-k-button">
                                            <i className="fas fa-plus-circle"></i>
                                            <span>ADD NEW</span>
                                        </button>
                                        <a id="excel-ref" href={ROOT_API_URL + "/ManagePositionGroup/ExportToExcel"} display="none" download></a>
                                        <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                                            <i className="fas fa-file-export"></i>
                                            EXPORT TO EXCEL
                                        </button>
                                    </div>
                                </GridToolbar>
                                <Column filterable={false} cell={cellWithEditing(this.edit, this.toggleActive)} />
                                <Column field="Description" title="Name" filter="text" />
                                <Column field="PositionGroupType" title="Type" filter="text" />
                                <Column
                                    field="IsActive"
                                    title="Is Active"
                                    width="150vw"
                                    filterable={true}
                                    filter="boolean"
                                    className="isActive-column"
                                />
                            </Grid>
                        </div>
                    )
                }
                <div>
                    {!this.state.isSubmitted ?
                        <PositionGroupsLoader
                            dataState={this.state.dataState}
                            onDataRecieved={this.dataRecieved}
                        />
                        : ""
                    }
                </div>
                <div>
                    {
                        this.state.isPopupVisible ? (
                            <GroupForm
                                dataItem={this.state.groupInEdit}
                                save={this.save}
                                cancel={this.cancel}
                                addPositionGroup={this.props.addPositionGroup}
                                groupTypes={this.props.groupReducer.groupTypes}
                                updatePositionGroup={this.props.updatePositionGroup}
                            />
                        ) : ""
                    }
                </div>
            </div>

        );
    }
}

function mapStateToProps(state) {
    return {
        groupReducer: state.groupReducer,
        common: state.common
    };
}

export default connect(mapStateToProps, {
    addPositionGroup,
    updatePositionGroup,
    getGroupTypes
})(ManagePositionGroups);
